import { Component, inject, ViewChild } from '@angular/core';
import {
  FullCalendarComponent,
  FullCalendarModule,
} from '@fullcalendar/angular';
import {
  CalendarOptions,
  DayCellMountArg,
  EventClickArg,
  EventSourceInput,
} from '@fullcalendar/core';

import { FormsModule } from '@angular/forms';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import { CommonService, DateService } from '@tw/services';
import { TrackerService } from 'src/shared/services/tracker.service';

@Component({
  selector: 'tw-calendar',
  imports: [FormsModule, FullCalendarModule],
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
})
export class CalendarComponent {
  private commonService = inject(CommonService);
  private dateService = inject(DateService);
  private trackerService = inject(TrackerService);

  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
    headerToolbar: {
      left: 'prev,next today toggleWeekends',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
    },
    buttonText: {
      today: 'Today',
      month: 'Month',
      week: 'Week',
      day: 'Day',
      list: 'List',
    },
    weekends: true,
    editable: true,
    selectable: true,
    customButtons: {
      toggleWeekends: {
        text: 'Toggle Weekends',
        click: () => this.toggleWeekends(),
      },
    },
    dayCellDidMount: (mountArg: DayCellMountArg) =>
      this.onDayCellDidMount(mountArg),
    eventClick: (arg) => this.handleDateClick(arg),
  };

  calendarEvents: EventSourceInput = [];
  totalTimePerDate: Map<string, string> = new Map<string, string>(); // key = 'YYYY-MM-DD', value = 'HH:mm'

  handleDateClick(arg: EventClickArg) {
    console.log('Event clicked', arg);
  }

  toggleWeekends() {
    this.calendarOptions.weekends = !this.calendarOptions.weekends;
  }
  async onDayCellDidMount(mountArg: DayCellMountArg) {
    console.log('Day cell mounted', mountArg);
    const cellDate = this.dateService.format(mountArg.date, 'YYYY-MM-DD');
    const response = await this.trackerService.getTrack(cellDate, cellDate);
    const totalTime = response.totalTimeSpent || '00:00';

    const dayOfWeek = mountArg.date.getDay(); // 0 = Sunday, 6 = Saturday
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      return;
    }
    // Safe manual split
    const [hoursStr, minutesStr] = totalTime.split(':');
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
    const decimalHours = +(Math.random() * 10).toFixed(2);
    console.log(
      `Date: ${cellDate}, Total Time: ${totalTime}, Decimal Hours: ${decimalHours}`,
    );

    if (decimalHours === 0) {
      mountArg.el.style.backgroundColor = '';
    } else if (decimalHours > 8) {
      mountArg.el.style.backgroundColor = '#d6f5e3';
    } else if (decimalHours >= 7) {
      mountArg.el.style.backgroundColor = '#fff9db';
    } else {
      mountArg.el.style.backgroundColor = '#ffe5e5';
    }
    mountArg.el.title = `Total time spent: ${totalTime}`;
    const timeDisplay = document.createElement('div');
    timeDisplay.innerText = totalTime;
    timeDisplay.style.fontSize = '10px';
    timeDisplay.style.marginTop = '4px';
    timeDisplay.style.color = '#444';

    // Append to bottom of cell content
    mountArg.el.appendChild(timeDisplay);
  }
}
